import { newTrigramTypePipe } from '~/filters/newTrigramTypePipe';
import { humanReadableField } from '~/filters/humanReadableField';

export function humanReadableDeviceTitle(type: string) {
    return `${humanReadableField(type)} - ${newTrigramTypePipe(type)}`;
}
